import React from "react"
import { ZoneEntity } from "../lib/types/zone"
import { getZonesGeojsonWithAllProps, ZoneProperties } from "../lib/helpers/map"
import GeoJson from "./GeoJson"
import { GeoJsonLayerStyle } from "../lib/helpers/googleMap"

interface ZoneLayerProps {
  mapId: string
  zones: ZoneEntity[] | undefined
  showZones: boolean
  properties: ZoneProperties
  onClick?: (zone: ZoneEntity | undefined) => void
  layerStyle?: GeoJsonLayerStyle
}

const ZoneLayer: React.FC<ZoneLayerProps> = ({
  mapId,
  zones,
  showZones,
  properties,
  onClick,
  layerStyle,
}) => {
  const geoJson = React.useMemo(() => {
    if (!zones || zones.length === 0 || !showZones) {
      return
    }

    return getZonesGeojsonWithAllProps(zones, properties)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showZones, zones, properties]) as object

  const geoJsonClickHandler = React.useMemo(() => {
    if (!zones || !onClick || typeof onClick !== "function") {
      return
    }

    return (event: any) => {
      const zoneUuid = event?.feature?.getProperty("uuid")
      const clickedZone = zones?.find((zone) => zone.uuid === zoneUuid)
      onClick(clickedZone)
    }
  }, [onClick, zones])

  return (
    <>
      {showZones ? (
        <GeoJson mapId={mapId} geoJson={geoJson} style={layerStyle} onClick={geoJsonClickHandler} />
      ) : null}
    </>
  )
}

export default ZoneLayer
